// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1t_b1","footer":"ModalFilter_footer__2ur6l"};